import React from "react";
import { Drawer, Row, Col, Button } from "antd";
import Keyboard from "react-simple-keyboard";
import TextArea from "antd/lib/input/TextArea";
import Close from "../../../../assets/images/close-x.svg";

/**
 * RejectQuotationDrawer
 *
 * Bottom drawer shown when a quotation is rejected.
 * Contains a notes textarea + on-screen keyboard.
 */
const RejectQuotationDrawer = ({
  rejectQuotation,
  setRejectQuotation,
  onChange,
  keyboardRef,
  handleShift,
  layoutName,
  setLayoutName,
  onAddNotes,
  loader,
  modalEditState,
  returnProcessRef,
  setShowReturnPurchase,
}) => {
  return (
    <Drawer
      placement="bottom"
      height="72vh"
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "2vh",
            fontSize: "1vw",
          }}
        >
          <p
            style={{
              fontSize: "1.5em",
              marginTop: "3vh",
              fontWeight: "500",
              color: "#0F0718",
              flex: 1,
              textAlign: "center",
            }}
          >
            Reject Quotation
          </p>
          <img
            src={Close}
            onClick={() => {
              setRejectQuotation(false);
            }}
            style={{
              marginLeft: "auto",
              paddingBottom: "4vh",
              paddingTop: "2vh",
              cursor: "pointer",
              width: "1.5vw",
            }}
          />
        </div>
      }
      closeIcon={null}
      className="filter"
      styles={{ body: { paddingTop: 0 } }}
      open={rejectQuotation}
      closable={true}
      onClose={() => {
        setRejectQuotation(false);
      }}
      footer={null}
    >
      <Row style={{ padding: "0 5vw", fontSize: "1vw", paddingTop: "2vh" }}>
        <Col span={11}>
          <span
            style={{
              fontFamily: "Inter",
              fontSize: "1.25em",
              color: "#0F0718",
              fontWeight: 500,
            }}
          >
            Reject Notes
          </span>
          <TextArea
            id="notes-input"
            style={{ resize: "none", paddingTop: "2vh" }}
            maxLength={200}
            placeholder="Type Here"
            rows={11}
          />
        </Col>
        <Col span={12} offset={1} style={{ marginTop: "4vh" }}>
          <Keyboard
            theme={"hg-theme-default aprvl"}
            onChange={(input) => onChange(input)}
            keyboardRef={(r) => (keyboardRef.current = r)}
            onKeyPress={(button) => {
              if (button === "{shift}" || button === "{lock}") handleShift();
              if (button === "{number}") {
                setLayoutName("number");
              }
              if (button === "{numbers}") {
                setLayoutName("numbers");
              }
              if (button === "{small}") {
                setLayoutName("shift");
              }
              if (button === "{caps}") {
                setLayoutName("default");
              }
              if (button === "{enter}") {
                onAddNotes();
              }
            }}
            layoutName={layoutName}
            display={{
              "{abc}": "ABC",
              "{smileys}": "\uD83D\uDE03",
              "{back}": "Enter",
              "{numbers}": "123",
              "{number}": "123",
              "{bksp}": "backspace",
              "{backspace}": "⌫",
              "{shift}": "⇧",
              "{tab}": "tab",
              "{lock}": "lock",
              "{enter}": "Enter",
              "{space}": "Space",
              "{caps}": "ABC",
              "{small}": "abc",
            }}
            layout={{
              shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {backspace}", "{number} {space} {enter}"],
              numbers: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{caps} {space} {enter}"],
              number: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{small} {space} {enter}"],
              default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {backspace}", "{numbers} {space} {enter}"],
            }}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: "2.3vh", fontSize: "1vw" }} gutter={[16]}>
        <Col span={12} />
        <Col span={5} style={{ textAlign: "right", marginLeft: "1.6vw" }}>
          <Button
            style={{ width: "100%", height: "7.5vh", fontSize: "1.5em", fontWeight: "500", color: "#000", borderRadius: "5px" }}
            onClick={() => setShowReturnPurchase(false)}
            disabled={loader}
          >
            Cancel
          </Button>
        </Col>
        <Col span={5} style={{ textAlign: "right" }}>
          <Button
            style={{ width: "100%", height: "7.5vh", fontSize: "1.5em", fontWeight: "500", color: "#fff", background: "#2F3856", borderRadius: "5px" }}
            ref={returnProcessRef}
            disabled={modalEditState || loader}
            className="focusDashboardCard"
          >
            Confirm
          </Button>
        </Col>
      </Row>
    </Drawer>
  );
};

export default RejectQuotationDrawer;
